import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/client")({
  beforeLoad: async () => {
    const res = await fetch("/api/auth/get-session");
    if (!res.ok) throw redirect({ to: "/login" });
    const session = await res.json();
    if (!session?.user) throw redirect({ to: "/login" });
    if (session.user.role !== "client") throw redirect({ to: "/dashboard" });
    return { session };
  },
  component: () => <Outlet />,
});
